import { asyncByRecipe, lazyValue, noop, valueProvider } from '@proc7ts/primitives';
import { AbortedZExecutionError } from './aborted-execution-error.js';
/**
 * Starts execution by the given starter.
 *
 * @typeParam TResult  Execution result type.
 * @param starter - Execution starter function.
 *
 * @returns New execution instance to start by the given starter.
 */
export function execZ(starter) {
    let start;
    let doNotStart;
    let whenStarted = () => {
        const result = new Promise((resolve, reject) => {
            start = resolve;
            doNotStart = reject;
        });
        whenStarted = valueProvider(result);
        return result;
    };
    start = () => {
        whenStarted = valueProvider(Promise.resolve());
    };
    doNotStart = (error) => {
        whenStarted = lazyValue(() => Promise.reject(error));
    };
    let initialize;
    let abort = () => {
        abort = noop;
        initialize = init => {
            var _a;
            (_a = init.abort) === null || _a === void 0 ? void 0 : _a.call(init);
        };
        doNotStart(new AbortedZExecutionError());
    };
    initialize = init => {
        initialize = noop;
        abort = () => {
            var _a;
            abort = noop;
            (_a = init.abort) === null || _a === void 0 ? void 0 : _a.call(init);
        };
        Promise.resolve()
            .then(() => { var _a; return (_a = init.whenStarted) === null || _a === void 0 ? void 0 : _a.call(init); })
            .then(() => start(), error => doNotStart(error));
    };
    const done = () => {
        abort = noop;
    };
    const whenDone = asyncByRecipe(starter)
        .then(init => {
        initialize(init);
        return Promise.resolve(init.whenDone()).finally(done);
    })
        .catch(error => {
        doNotStart(error);
        return Promise.reject(error);
    });
    return {
        whenStarted() {
            return whenStarted();
        },
        whenDone() {
            return whenDone;
        },
        abort() {
            abort();
        },
    };
}
//# sourceMappingURL=exec.js.map